import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IMainMenuSettings } from '../../../interface/main-menu-settings.interface';

export const updateMainMenuSettings = (mainMenu: IMainMenuSettings) => returnAction<IMainMenuSettings>(ActionEnum.SETTINGS_UPDATE_MAIN_MENU_SETTINGS, mainMenu);
